import React, { ChangeEvent, useState } from "react";

import { useProfile } from "@/customHooks/useProfile";
import { useTranslation } from "next-i18next";
import toast from "react-hot-toast";
import { Folder } from "~types/folder";

import { FolderDeleteDialog } from "@/components/blocks/search/folder-delete-dialog/FolderDeleteDialog";
import { FolderEditDrawer } from "@/components/blocks/search/folder-edit-drawer/FolderEditDrawer";
import { SwipeableEdgeDrawer } from "@/components/elements/bottom-drawer-with-edge/BottomDrawerWithEdge";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme
} from "@mui/material";

import PencilIcon from "~public/icons/Pencil/Pencil.svg";
import ShareIcon from "~public/icons/Share/Share.svg";
import TrashIcon from "~public/icons/Trash/Trash.svg";

interface FolderMoreDrawerProps {
  isOpen: boolean;
  closeFolderDrawer: any;
  toggleDrawer: any;
  folder: Folder;
}

export const FolderMoreDrawer = ({
  isOpen,
  toggleDrawer,
  closeFolderDrawer,
  folder
}: FolderMoreDrawerProps): JSX.Element => {
  const { createFolder } = useProfile();
  const { t } = useTranslation("searchpage");
  const theme = useTheme();
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState<boolean>(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);

  const [folderName, setFolderName] = useState<string>("");

  const handleChangeFolderName = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setFolderName(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    return createFolder.mutateAsync({ folderName });
  };

  const handleToggleDeleteDialog = (value: boolean) => {
    setIsDeleteDialogOpen(value);
  };

  const handleToggleEditDrawer = (value: boolean) => {
    setIsEditDrawerOpen(value);
  };

  const handleClickEdit = () => {
    handleToggleEditDrawer(true);
  };

  const handleClickDelete = () => {
    handleToggleDeleteDialog(true);
  };

  const handleClickShare = () => {
    toast.success("Share");
  };

  return (
    <SwipeableEdgeDrawer
      isOpen={isOpen}
      toggleDrawer={toggleDrawer}
      disableGutters>
      <List
        sx={{
          "& .MuiListItemButton-root": {
            // paddingLeft: 24,
            // paddingRight: 24
          },
          "& .MuiListItemIcon-root": {
            minWidth: 0,
            marginRight: 1.25
          }
        }}>
        <ListItem disablePadding>
          <ListItemButton onClick={handleClickEdit}>
            <ListItemIcon>
              <PencilIcon style={{ fontSize: 24 }} />
            </ListItemIcon>
            <ListItemText primary={t("favourites.more-drawer.edit")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={handleClickDelete}>
            <ListItemIcon>
              <TrashIcon style={{ fontSize: 24 }} />
            </ListItemIcon>
            <ListItemText primary={t("favourites.more-drawer.delete")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={handleClickShare}>
            <ListItemIcon>
              <ShareIcon style={{ fontSize: 24 }} />
            </ListItemIcon>
            <ListItemText primary={t("favourites.more-drawer.share")} />
          </ListItemButton>
        </ListItem>
      </List>
      <FolderEditDrawer
        isOpen={isEditDrawerOpen}
        toggleDrawer={handleToggleEditDrawer}
        closeFolderDrawer={closeFolderDrawer}
        closeMoreDrawer={() => toggleDrawer(false)}
        folder={folder}
      />
      <FolderDeleteDialog
        isOpen={isDeleteDialogOpen}
        closeFolderDrawer={closeFolderDrawer}
        closeMoreDrawer={() => toggleDrawer(false)}
        toggleDrawer={handleToggleDeleteDialog}
        folder={folder}
      />
    </SwipeableEdgeDrawer>
  );
};
